import * as React from 'react';
import { Button } from '@/components';
import { useEffect, useState } from 'react';
import { getBrandToken } from '@/api';
import { useStyles } from './styles';
import { useAppData } from '@/zustand/useAppData';
import { useAssetsData } from '@/zustand/useAssetsData';

export const DashboardButton = () => {
  const { id } = useAppData((store) => store.appData);
  const {
    assetsData: {
      behavior_list: { configurator_url, enable_attendant_dashboard_access }
    }
  } = useAssetsData((store) => store) || {};
  const styles = useStyles();

  const [dashboardUrl, setDashboardUrl] = useState(null);

  const getDashboardUrl = async () => {
    if (configurator_url && enable_attendant_dashboard_access === 'true') {
      const { token } = await getBrandToken(id);
      const baseUrl = configurator_url.split('/').slice(0, 3).join('/');
      token && setDashboardUrl(`${baseUrl}/attendants/${token}/dashboards`);
    }
  };
  useEffect(() => {
    getDashboardUrl();
  }, []);

  return (
    <>
      {dashboardUrl && (
        <Button
          onClick={() => window.open(dashboardUrl)}
          className={styles.dashboardButton}
          text="MTM Dashboard"
          size="large"
        />
      )}
    </>
  );
};
